import { modularScale } from '../utils';
export const sharedTheme = {
    ms: (v) => modularScale(v),
    fonts: {
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        codeFontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
        textSizeSmall: modularScale(-1),
        textSizeStandard: modularScale(0),
        textSizeXXL: modularScale(5),
        textSizeXL: modularScale(4),
        textSizeH1: modularScale(3),
        textSizeH2: modularScale(2),
        textSizeH3: modularScale(1)
    },
    weight: {
        semiBold: 500,
        bold: 600
    }
};
export var PaletteModeType;
(function (PaletteModeType) {
    PaletteModeType["light"] = "light";
    PaletteModeType["dark"] = "dark";
})(PaletteModeType || (PaletteModeType = {}));
//# sourceMappingURL=SharedTheme.js.map